import { sortBy } from "lodash"
import { AutoComplete, Input } from "antd"
import * as React from "react"
import { Router } from "../../../../server/router"
import * as Color from "../../../../constants/colors"
import { AntdIconWrap } from "../../../uiKit/Icons/AntdIconWrap"
import { appendToPathname } from "../../../../utils/url"

export type AutoCompleteSelectionItem = {
    id: string
    title: string
}

type Props = {
    addSelectionTitle: string
    selections: AutoCompleteSelectionItem[]
    height: string
    handleClose: () => void
    handleSelected: (id: string) => void
    createNewDisabled?: boolean
    path?: string
}

class AssignItemAutoComplete extends React.PureComponent<Props> {
    static defaultProps = {
        path: "modal/add-modifier",
    }
    filterOption = (inputValue: string, option: Record<string, any>) => {
        if (typeof option.props.children === "string") {
            return option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
        } else {
            return null
        }
    }
    onSelect = (value: string) => {
        // @ts-expect-error
        const asPath = Router && Router.router.asPath

        switch (value) {
            case "add-start":
            case "add-end":
                if (this.props.path) {
                    Router.push(appendToPathname(asPath, this.props.path))
                    this.props.handleClose()
                }

                break

            default: {
                this.props.handleSelected(value)
            }
        }
    }
    closeAutoCompletion = () => {
        this.props.handleClose()
    }
    getCreateNewOption = (key: string) => (
        <AutoComplete.Option
            key={key}
            value={key}
            title={this.props.addSelectionTitle}
            style={{
                borderTop: `1px solid ${Color.antBorder}`,
                borderBottom: `1px solid ${Color.antBorder}`,
                padding: "0.75rem",
                color: `${Color.PrimaryColor}`,
            }}>
            <AntdIconWrap
                type="plus"
                theme="outlined"
                style={{
                    marginRight: "1rem",
                }}
            />
            {this.props.addSelectionTitle}
        </AutoComplete.Option>
    )
    renderContent = () => {
        const k = sortBy(this.props.selections, "title").map(group => (
            <AutoComplete.Option key={group.id} value={group.id}>
                {group.title}
            </AutoComplete.Option>
        ))

        if (!this.props.createNewDisabled) {
            k.unshift(this.getCreateNewOption("add-start"))
        }

        return k
    }

    render() {
        return (
            <div>
                <AutoComplete
                    autoFocus={true}
                    defaultOpen={true}
                    style={{
                        width: "100%",
                        height: `${this.props.height}`,
                    }}
                    dataSource={this.renderContent()}
                    // @ts-expect-error
                    filterOption={this.filterOption}
                    onSelect={this.onSelect}>
                    <Input
                        style={{
                            height: `${this.props.height}`,
                        }}
                        suffix={
                            <AntdIconWrap
                                style={{
                                    fontSize: "1rem",
                                    color: "#EF5350",
                                    position: "relative",
                                    right: "1rem",
                                }}
                                type="close-circle"
                                onClick={this.closeAutoCompletion}
                            />
                        }
                    />
                </AutoComplete>
            </div>
        )
    }
}

export default AssignItemAutoComplete
